import axios from 'axios'

export default {
    getIndex: (filters) => axios.post('import-historic',filters),
    delete: (filter) => axios.post('import-historic/delete', filter)
}